var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "approved" }, [
      _c("div", { staticClass: "approved-content" }, [
        _vm.status === 2 || _vm.status === 4
          ? _c("div", [
              _c("div", { staticClass: "approved-content-title" }, [
                _c("div", [
                  _c("span", { staticClass: "medium" }, [_vm._v("Brand: ")]),
                  _c("span", [_vm._v(_vm._s(_vm.message.brandName))])
                ]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.message.createAt))])
              ]),
              _vm._v(" "),
              _vm._m(0)
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.status === 60 || _vm.status === 61
          ? _c("div", [
              _c("div", { staticClass: "approved-content-title" }, [
                _c("div", [
                  _c("span", { staticClass: "medium" }, [_vm._v("Brand: ")]),
                  _c("span", [_vm._v(_vm._s(_vm.message.brandName))])
                ]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.message.createAt))])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "approved-content-text" }, [
                _c("div", [_vm._v("Refund is denied")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("Denial Reason: " + _vm._s(_vm.message.reason))
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.status === 5
          ? _c("div", [
              _c("div", { staticClass: "approved-content-title" }, [
                _c("div", [
                  _c("span", { staticClass: "medium" }, [_vm._v("Brand: ")]),
                  _c("span", [_vm._v(_vm._s(_vm.message.username))])
                ]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.message.createAt))])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "approved-content-text" }, [
                _c("div", [
                  _vm._v(
                    "The Retailer (" +
                      _vm._s(_vm.message.username) +
                      ")  cancel order"
                  )
                ])
              ])
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "approved-content-text" }, [
      _c("div", [
        _vm._v("The Service Order has been approved and the refund is pending")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-218d7518", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d7518","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/service-order/components/history-list/approved.vue
// module id = cdHM
// module chunks = 2